import { addTokenToUrl, ApiClient } from "@/services/apiClient";

export type ParameterValueSaveData = {
  itemId: number;
  parameterId: number;
  type: "custom" | "predefined";
  value: number | string;
};

/** @deprecated Oldschool response -> BE rework needed @todo */
type ApiResponse_SaveSelectedValue =
  | {
      result: "ok";
      id: number;
    }
  | {
      result: "error";
      message: string;
    }
  | {
      status: "error";
      message: string;
    };

/** @deprecated Should be reworked into @/services/collection/parameters/api */
export function useParametersApi() {
  const BaseUrl = "collection/parameters/";

  const saveSelectedValue = async (data: ParameterValueSaveData): Promise<ApiResponse_SaveSelectedValue> => {
    const url = addTokenToUrl(BaseUrl + "save-selected-value");
    return ApiClient.post<ApiResponse_SaveSelectedValue>(url, {}, data).then(({ data }) => data);
  };

  return {
    saveSelectedValue,
  };
}
